module.exports = __webpack_public_path__ + "static/media/saving-jars.1b1d5dcc.png";